"use client";

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import { cn } from '../lib/utils';
import { useFieldControl } from '../lib/field';

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer group/checkbox grid size-4 shrink-0 place-items-center rounded-sm border border-input bg-surface text-accent-foreground shadow-xs',
      'transition-colors duration-[var(--duration-fast)] hover:border-muted-foreground',
      'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring',
      'aria-[invalid=true]:border-danger',
      'data-[state=checked]:border-accent data-[state=checked]:bg-accent data-[state=indeterminate]:border-accent data-[state=indeterminate]:bg-accent',
      'disabled:cursor-not-allowed disabled:border-border disabled:bg-muted disabled:data-[state=checked]:bg-disabled disabled:data-[state=checked]:border-disabled',
      className
    )}
    {...useFieldControl(props, { required: false })}
  >
    <CheckboxPrimitive.Indicator className="grid place-items-center text-current">
      <Check className="size-3.5 group-data-[state=indeterminate]/checkbox:hidden" strokeWidth={3} />
      <Minus className="hidden size-3.5 group-data-[state=indeterminate]/checkbox:block" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));

Checkbox.displayName = CheckboxPrimitive.Root.displayName;
